import { Table, TableBody, TableCell, TableRow, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { ReporteDeudaType } from '../../hooks/getDeuda';
import hash from 'object-hash';
import { lightDefaultColor } from '../../utils/constants';
import { DeudaFamiliarType } from './DeudaReportFamiliar';
import dayjs from 'dayjs';




export function TablaFamiliarPagos(props:{ deudaFamiliar?:DeudaFamiliarType }) {
  const { deudaFamiliar } = props;
  const theme = useTheme();

  if (!deudaFamiliar) return null;

  return (
    <Table style={{ margin: 6 }}>
      <TableBody>
        <TableRow
          key={'encabezado-table-pagos'}
          style={{ borderStyle: 'solid', height: 20, backgroundColor: lightDefaultColor }}
        >
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Nombre</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Monto</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Descuento</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Monto con descuento</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Saldado (fecha)</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Saldado (monto)</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold' }}>Pendiente</TableCell>
        </TableRow>
        {deudaFamiliar.cuotas.map((pago:ReporteDeudaType) => {
          const totalPagado = pago?.pagos?.reduce((t:number, p) => p.importe ? t += + p.importe : t, 0) ?? 0;
          const pendiente = (pago?.monto ?? 0) - (totalPagado ?? 0);
          if (pago.error) return (
            <TableRow
              key={hash(pago)}
              style={{ borderStyle: 'solid' }}
            >
              <TableCell style={{ padding: '0px 16px' }}>{pago.nombre}</TableCell>
              <TableCell style={{ padding: '0px 16px', color: 'red' }} colSpan={5}>{`${pago.error}`}</TableCell>
            </TableRow>
          );
          return (
            <TableRow
              key={hash(pago)}
              style={{ borderStyle: 'solid' }}
            >
              <TableCell style={{ padding: '0px 16px' }}>{pago.nombre}</TableCell>
              {pago.inactivo ? <TableCell style={{ padding: '0px 16px' }}>INACTIVO</TableCell>
                : (
                  <>
                    <TableCell style={{ padding: '0px 16px' }}>{`$${pago.montoOriginal.toFixed(2)}`}</TableCell>
                    <TableCell style={{ padding: '0px 16px' }}>{pago.descuento ? `${pago.descuento.toFixed(2)}%` : '-'}</TableCell>
                    <TableCell style={{ padding: '0px 16px' }}>{`$${pago.monto.toFixed(2)}`}</TableCell>
                    <TableCell style={{ padding: '0px 16px' }}>
                      {pago?.pagos && !pago.pagos.length ? '-'
                        : pago.pagos.length > 1 ? 'Multiples pagos'
                          : dayjs(pago?.pagos?.[0]?.fecha).format('DD/MM/YYYY') ?? '-'}
                    </TableCell>
                    <TableCell style={{ padding: '0px 16px' }}>{totalPagado > 0 ? `$${totalPagado.toFixed(2)}` : '-'}</TableCell>
                    <TableCell style={{ padding: '0px 16px' }}>{pago?.saldado || !pendiente
                      ? <Typography fontSize={14} color={theme.palette.success.main}>saldado</Typography>
                      : `$${pendiente.toFixed(2)}`}
                    </TableCell>
                  </>
                )}
            </TableRow>
          );
        })}
        <TableRow
          key="total"
          style={{ borderStyle: 'solid', borderWidth: 3 }}
        >
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold', fontSize: 16 }}>TOTALES</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold', fontSize: 16 }}>{`$${deudaFamiliar.totalOriginal.toFixed(2)}`}</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold', fontSize: 16 }}/>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold', fontSize: 16 }}>{`$${deudaFamiliar.totalAPAgar.toFixed(2)}`}</TableCell>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold', fontSize: 16 }}/>
          <TableCell style={{ padding: '0px 16px', fontWeight: 'bold', fontSize: 16 }}>{`$${deudaFamiliar.totalPagado.toFixed(2)}`}</TableCell>
          <TableCell
            style={{
              padding: '0px 16px',
              fontWeight: 'bold',
              fontSize: 20,
              color: deudaFamiliar.totalAdeudado <= 0 ? theme.palette.success.main : undefined,
            }}>
            {deudaFamiliar.totalAdeudado <= 0 ? 'saldado' : `$${deudaFamiliar.totalAdeudado.toFixed(2)}`}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>);
}